module.exports = __webpack_public_path__ + "img/1b35a8a.jpg";